import { PropsWithChildren, useMemo } from 'react';
import { useTranslation } from '@sib/i18n';
import { CopyToClipboardConfigContext } from '@sib/ui/hooks';
import { useNotification } from '../notification-provider/use-notification';

export const CopyToClipboardToastProvider = ({
  children,
}: PropsWithChildren) => {
  const { open } = useNotification();
  const { t } = useTranslation();

  const value = useMemo(
    () => ({
      onCopySuccess: () =>
        open({
          message: t('copyToClipboard'),
          type: 'success',
        }),
    }),
    [open, t]
  );

  return (
    <CopyToClipboardConfigContext.Provider value={value}>
      {children}
    </CopyToClipboardConfigContext.Provider>
  );
};
